// src/plugins/newrelic.js
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

const options = {
  init: {
    browser_consent_mode: { enabled: false },
    privacy: { cookies_enabled: true },
    distributed_tracing: { enabled: true },
    performance: { capture_measures: true },
    ajax: { deny_list: [ 'bam.eu01.nr-data.net' ], capture_payloads: 'none' }
  },
  info: { beacon: 'bam.eu01.nr-data.net', errorBeacon: 'bam.eu01.nr-data.net', licenseKey: 'NRJS-5603d7ace820c6b3da9', applicationID: '538861551', sa: 1 },
  loader_config: { accountID: '7212099', trustKey: '7212099', agentID: '538861551', licenseKey: 'NRJS-5603d7ace820c6b3da9', applicationID: '538861551' }
};

export const nrAgent = new BrowserAgent(options);

export function reportMemory(context = {}) {
  if (!performance.memory) {
    console.warn('no performance memory info available');

    return;
  }

  const { userName = '', laboratory = '' } = context;

  nrAgent.addPageAction('memorySnapshot', {
    UsedJSHeapSize: performance.memory.usedJSHeapSize,
    TotalJSHeapSize: performance.memory.totalJSHeapSize,
    UsedPercent: (performance.memory.usedJSHeapSize / performance.memory.jsHeapSizeLimit) * 100,
    UserName: userName,
    Laboratory: laboratory
  });
}
